import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetMentorshipProgramLocationUsersByIdQueryVariables = Types.Exact<{
  programId: Types.Scalars['Int']['input'];
  userWhere?: Types.InputMaybe<Types.Users_Bool_Exp>;
}>;


export type GetMentorshipProgramLocationUsersByIdQuery = { __typename?: 'query_root', mentorshipProgram: Array<{ __typename?: 'mentorshipProgram', id: number, workspaceLocation?: { __typename?: 'workspaceLocations', workspaceLocationUsers: Array<{ __typename?: 'users', id: string, firstName: string, lastName: string, profilePhotoLink?: string | null, mentorEnabled?: boolean | null, menteeEnabled?: boolean | null }> } | null }> };


export const GetMentorshipProgramLocationUsersByIdDocument = gql`
    query getMentorshipProgramLocationUsersById($programId: Int!, $userWhere: users_bool_exp) {
  mentorshipProgram(where: {id: {_eq: $programId}}) {
    id
    workspaceLocation {
      workspaceLocationUsers(where: $userWhere) {
        id
        firstName
        lastName
        profilePhotoLink
        mentorEnabled
        menteeEnabled
      }
    }
  }
}
    `;

/**
 * __useGetMentorshipProgramLocationUsersByIdQuery__
 *
 * To run a query within a React component, call `useGetMentorshipProgramLocationUsersByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMentorshipProgramLocationUsersByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMentorshipProgramLocationUsersByIdQuery({
 *   variables: {
 *      programId: // value for 'programId'
 *      userWhere: // value for 'userWhere'
 *   },
 * });
 */
export function useGetMentorshipProgramLocationUsersByIdQuery(baseOptions: Apollo.QueryHookOptions<GetMentorshipProgramLocationUsersByIdQuery, GetMentorshipProgramLocationUsersByIdQueryVariables> & ({ variables: GetMentorshipProgramLocationUsersByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMentorshipProgramLocationUsersByIdQuery, GetMentorshipProgramLocationUsersByIdQueryVariables>(GetMentorshipProgramLocationUsersByIdDocument, options);
      }
export function useGetMentorshipProgramLocationUsersByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMentorshipProgramLocationUsersByIdQuery, GetMentorshipProgramLocationUsersByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMentorshipProgramLocationUsersByIdQuery, GetMentorshipProgramLocationUsersByIdQueryVariables>(GetMentorshipProgramLocationUsersByIdDocument, options);
        }
export function useGetMentorshipProgramLocationUsersByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMentorshipProgramLocationUsersByIdQuery, GetMentorshipProgramLocationUsersByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMentorshipProgramLocationUsersByIdQuery, GetMentorshipProgramLocationUsersByIdQueryVariables>(GetMentorshipProgramLocationUsersByIdDocument, options);
        }
export type GetMentorshipProgramLocationUsersByIdQueryHookResult = ReturnType<typeof useGetMentorshipProgramLocationUsersByIdQuery>;
export type GetMentorshipProgramLocationUsersByIdLazyQueryHookResult = ReturnType<typeof useGetMentorshipProgramLocationUsersByIdLazyQuery>;
export type GetMentorshipProgramLocationUsersByIdSuspenseQueryHookResult = ReturnType<typeof useGetMentorshipProgramLocationUsersByIdSuspenseQuery>;
export type GetMentorshipProgramLocationUsersByIdQueryResult = Apollo.QueryResult<GetMentorshipProgramLocationUsersByIdQuery, GetMentorshipProgramLocationUsersByIdQueryVariables>;